import {ErrorHandler as AngularErrorHandler, NgModule} from '@angular/core'
// import { ErrorHandler as AngularErrorHandler } from '@angular/core';
import {BrowserModule, platformBrowser} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {ExtraOptions, NoPreloading, RouterModule} from '@angular/router'
import {MarkdownModule} from 'ngx-markdown'
import {FuseModule} from '@fuse'
import {FuseConfigModule} from '@fuse/services/config'
import {FuseMockApiModule} from '@fuse/lib/mock-api'
import {CoreModule} from 'app/core/core.module'
import {appConfig} from 'app/core/config/app.config'
import {mockApiServices} from 'app/mock-api'
import {LayoutModule} from 'app/layout/layout.module'
import {AppComponent} from 'app/app.component'
import {appRoutes} from 'app/app.routing'
import {EffectsModule} from '@ngrx/effects'
import {StoreModule} from '@ngrx/store'
import {StoreDevtoolsModule} from '@ngrx/store-devtools'
import {clearState, reducers} from "@store/appState"
import {ToastrModule} from "ngx-toastr"
import {FIREBASE_OPTIONS} from '@angular/fire/compat'
import {environment} from 'environments/environment'
import {AskForLangModule} from "./modules/ask-for-lang/ask-for-lang.module"
import Bugsnag from '@bugsnag/js'
// import {CustomErrorHandler} from 'app/custom-providers/custom-error-handler'
import {AngularSplitModule} from "angular-split";
import {SharedModule} from "@store/shared.module";

const routerConfig: ExtraOptions = {
  preloadingStrategy: NoPreloading,
  scrollPositionRestoration: 'enabled'
}

// Bugsnag.start({
//   releaseStage: environment.bugsnagStage,
//   apiKey: 'ad31133c8c816f73669e3fc9e7cd75de',
//   enabledReleaseStages: ['production'],
//   releaseStage: environment?.production ? 'production' : 'approbation',
//   onError: (event) => {
//     const file: string = event?.errors?.[0]?.stacktrace?.[0]?.file;
//     if (file.includes('node_modules') || file.includes('vendor') || file.includes('recaptcha')) {
//       console.log('[BugSnagOnError] ------------->', event?.errors?.[0]?.stacktrace?.[0]?.file);
//       return false;
//     }
//     return true;
//   }
// }
//
// })

Bugsnag.start(
  {
    apiKey: 'ad31133c8c816f73669e3fc9e7cd75de',
    enabledReleaseStages: ['production', 'staging'],
    releaseStage: environment.bugsnagStage,
    onError: (event) => {
      const file: string = event?.errors?.[0]?.stacktrace?.[0]?.file;
      if (file.includes('node_modules') || file.includes('vendor') || file.includes('recaptcha')) {
        console.log('[BugSnagOnError] ------------->', event?.errors?.[0]?.stacktrace?.[0]?.file);
        return false;
      }
      return true;
    }
  }
);


// export function errorFactory() {
//   return new CustomErrorHandler()
// }

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),

    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),

    // Core module of your application
    CoreModule,

    // Layout module of your application
    LayoutModule,

    // 3rd party modules that require global configuration via forRoot
    MarkdownModule.forRoot({}),

    // RxJS init
    EffectsModule.forRoot([]),
    StoreModule.forRoot(reducers,
      {
        metaReducers: [clearState],
        runtimeChecks: {
          // //
          // // Gridster fait chier...
          // //
          // strictStateImmutability: true,
          // strictActionImmutability: true,
          // //
          // //
        },
      }),
    StoreDevtoolsModule.instrument({
      maxAge: 50,
    }),

    ToastrModule.forRoot(),
    AskForLangModule,

    AngularSplitModule,
    SharedModule,

  ],
  providers: [
    {
      provide: FIREBASE_OPTIONS,
      useValue: environment.firebaseConfig,
    },
    {
      provide: AngularErrorHandler,
      // useFactory: errorFactory
    },
    // provideExperimentalZonelessChangeDetection(),
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
}
platformBrowser().bootstrapModule(AppModule);
